import { useState, useEffect, useRef, useMemo } from 'react';
import api from '../services/api';
import './Admin.css';
import { validateVehicleForm } from '../utils/validation';
import LogoutButton from '../components/LogoutButton';
import HomeButton from '../components/HomeButton';



// no topo, após os imports
export const ADMIN_PANEL_VERSION = '1.0.0'; // << troque aqui quando fizer release

// Ordem de exibição
const CATEGORY_ORDER = [
  'Segurança',
  'Iluminação & Visibilidade',
  'Conforto',
  'Infotainment',
  'Condução & Desempenho',
  'Estacionamento & Câmeras',
  'Exterior',
  'Utilitários',
  'Comercial/Leve',
  'Blindagem',
  'Conectividade',
  'Outros'
];

// Mapeamento de nomes -> categoria (use os mesmos nomes do seed)
const CATEGORY_SETS = {
  'Segurança': new Set([
    'Airbag frontal','Airbag lateral','Airbag de cortina','Freio ABS',
    'Controle de tração (TCS)','Controle de estabilidade (ESP/ESC)',
    'Assistente de partida em rampa (HSA)','Assistente de descida',
    'Isofix','Alerta de colisão','Frenagem autônoma de emergência (AEB)',
    'Alerta de faixa','Correção ativa de faixa (LKA)','Monitor de ponto cego',
    'Alerta de tráfego cruzado traseiro','Sensor de fadiga','Sistema anticapotamento',
    'Alarme','Imobilizador de motor'
  ]),
  'Iluminação & Visibilidade': new Set([
    'Faróis de LED','Faróis Full LED','Faróis Xenon','DRL (luz diurna)','Farol de neblina',
    'Limpador traseiro','Desembaçador traseiro','Retrovisor eletrocrômico',
    'Retrovisores elétricos','Rebatimento elétrico dos retrovisores','Desembaçador dos retrovisores',
    'Sensor de chuva','Sensor crepuscular'
  ]),
  'Conforto': new Set([
    'Ar-Condicionado','Ar-Condicionado Digital','Ar dual zone',
    'Bancos em Couro','Banco do motorista com ajuste de altura',
    'Banco do motorista com ajuste elétrico','Banco do passageiro com ajuste elétrico',
    'Banco com aquecimento','Banco com ventilação','Banco com memória',
    'Apoio de braço dianteiro','Apoio de braço traseiro',
    'Direção elétrica','Vidros elétricos dianteiros','Vidros elétricos traseiros',
    'Acionamento um-toque','Keyless entry','Keyless start (partida por botão)',
    'Fechamento global dos vidros','Porta-malas com abertura elétrica',
    'Porta-malas “mãos livres” (kick sensor)','Teto Solar','Teto Panoramico',
    'Iluminação interna ambiente','Carregador por indução','Tomadas 12V',
    'Portas USB dianteiras','Portas USB traseiras','Saídas de ar traseiras'
  ]),
  'Infotainment': new Set([
    'Central multimídia','Tela sensível ao toque','Apple CarPlay','Android Auto',
    'Navegação GPS nativa','Bluetooth','Comando de áudio no volante',
    'Computador de bordo','Painel de instrumentos digital','Head-Up Display (HUD)',
    'Sistema de som premium','Subwoofer'
  ]),
  'Condução & Desempenho': new Set([
    'Câmbio manual','Câmbio automático','Câmbio CVT','Paddle shift (borboletas)',
    'Piloto automático','Piloto automático adaptativo (ACC)','Suspensão adaptativa',
    'Seleção de modos de condução','Freio de estacionamento elétrico','Auto-hold',
    'Start/Stop','Tração 4x4','Bloqueio de diferencial','Redutor (4x4 reduzida)',
    'Freio a disco nas 4 rodas'
  ]),
  'Estacionamento & Câmeras': new Set([
    'Sensor de estacionamento dianteiro','Sensor de estacionamento traseiro',
    'Câmera de ré','Câmera 360°','Assistente de estacionamento automático'
  ]),
  'Exterior': new Set([
    'Rodas Liga leve','Rodas diamantadas','Pneus run-flat','Pintura metálica',
    'Pintura perolizada','Barra de teto','Estribo lateral','Protetor de cárter',
    'Engate de reboque (engate)','Aerofólio traseiro','Friso lateral'
  ]),
  'Utilitários': new Set([
    'Banco BiPartido','Rebatimento do banco traseiro bipartido',
    'Volante Multifuncional','Rede de porta-malas','Iluminação no porta-malas',
    'Tapete de borracha'
  ]),
  'Comercial/Leve': new Set([
    'Protetor de caçamba','Capota marítima','Santo Antônio','Ganchos de amarração'
  ]),
  'Blindagem': new Set([
    'Veículo blindado','Vidros blindados certificados'
  ]),
  'Conectividade': new Set([
    'Wi‑Fi a bordo','OnStar/Assistência conectada','Atualização OTA'
  ])
};


const DEFAULT_OPTION_NAMES = new Set([
  'Ar-Condicionado','Direção elétrica','Vidros elétricos dianteiros',
  'Travas elétricas','Alarme','Airbag frontal','Freio ABS',
  'Central multimídia','Bluetooth','Comando de áudio no volante',
  'Rodas Liga leve','Sensor de estacionamento traseiro','Câmera de ré',
  'Computador de bordo','Volante Multifuncional','Banco BiPartido'
]);

const BRAND_OPTIONS = [
  'audi','bmw','chery','citroen','fiat','ford','gm','hyundai',
  'jeep','kia','mercedes','mitsubishi','nissan','peugeot',
  'renault','toyota','volkswagen','volvo'
];

export default function Admin() {
  const auth = { username: 'admin', password: 'senhaSuperSecreta' };

  // listagens / formulário
  const [vehicles, setVehicles] = useState([]);
  const [optionsList, setOptionsList] = useState([]);
  const [form, setForm] = useState({
    brand: '', model: '', version: '', year: '',
    km: 0, price: 0, fipePrice: null, description: '',
    fuelType: '', transmission: '', engine: '',
    finalPlate: '', doors: 0, color: '', bodyType: '',
    inventoryType: 'locadora',
    videoUrl: '', active: true, options: [], photos: [],
    cur_pneus: '',
    cur_rodas: '',
    cur_interior: '',
    cur_pintura: '',
    cur_estrutura: '',
    cur_eletrica: '',
    cur_observacoes: '',
  });
  const [files, setFiles] = useState([]);
  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  // feedback
  const [notice, setNotice] = useState({ type: '', text: '' });
  const [saving, setSaving] = useState(false);
  const fileInputRef = useRef(null);

  // arquivos e status de upload dos laudos
const [reportFiles, setReportFiles] = useState({ cautelar: null, scanner: null });
const [reportUploading, setReportUploading] = useState({ cautelar: false, scanner: false });


  // versão exibida no cabeçalho (persistida)
  const [adminVersion, setAdminVersion] = useState(
    () => localStorage.getItem('adminVersion') || ''
  );
  useEffect(() => {
    localStorage.setItem('adminVersion', adminVersion);
  }, [adminVersion]);

  // confirmação de remoção (2 etapas)
  const [confirmingDeleteId, setConfirmingDeleteId] = useState(null);
  const [confirmTimer, setConfirmTimer] = useState(null);

  const rawBase = process.env.REACT_APP_API_URL || '';
  const API_BASE = rawBase.replace(/\/api$/, '');

  useEffect(() => {
    refresh();
    api.get('/options')
      .then(r => setOptionsList(r.data))
      .catch(err => {
        setNotice({ type: 'error', text: `Erro ao carregar opções: ${readErr(err)}` });
      });
  }, []);

  // marca todas opções por padrão (somente quando não está editando)
  useEffect(() => {
    if (optionsList.length && !editId) {
      setForm(f => ({ ...f, options: optionsList.map(o => o.id) }));
    }
  }, [optionsList, editId]);

  function refresh() {
    api.get('/vehicles')
      .then(r => setVehicles(r.data))
      .catch(err => setNotice({ type: 'error', text: `Erro ao listar veículos: ${readErr(err)}` }));
  }

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'active') {
      setForm(f => ({ ...f, [name]: checked }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };
  

  const handleNumberChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: Number(value) }));
  };

  const handleFipePriceChange = e => {
    const raw = e.target.value;

    setForm(f => {
      if (raw === '') {
        return { ...f, fipePrice: null };
      }

      const trimmed = raw.trim();
      if (trimmed === '') {
        return { ...f, fipePrice: null };
      }

      const cleaned = trimmed.replace(/[^0-9.,-]/g, '');
      if (cleaned === '') {
        return { ...f, fipePrice: null };
      }

      let sanitized = cleaned;
      if (sanitized.includes('.') && sanitized.includes(',')) {
        sanitized = sanitized.replace(/\./g, '').replace(',', '.');
      } else if (sanitized.includes(',')) {
        sanitized = sanitized.replace(',', '.');
      }

      const numeric = Number(sanitized);
      if (!Number.isFinite(numeric) || numeric < 0) {
        return { ...f, fipePrice: null };
      }

      return { ...f, fipePrice: numeric };
    });
  };

  // ...depois de handleCheck, ANTES do return (...)
const selectAllOptions = () => {
  setForm(f => ({ ...f, options: optionsList.map(o => o.id) }));
};

const clearAllOptions = () => {
  setForm(f => ({ ...f, options: [] }));
};

const selectDefaultOptions = () => {
  setForm(f => ({
    ...f,
    options: optionsList
      .filter(o => DEFAULT_OPTION_NAMES.has(o.name))
      .map(o => o.id)
  }));
};

const groupedOptions = useMemo(() => {
  const groups = Object.fromEntries(CATEGORY_ORDER.map(c => [c, []]));
  for (const o of optionsList) {
    const cat = Object.entries(CATEGORY_SETS)
      .find(([, set]) => set.has(o.name))?.[0] || 'Outros';
    groups[cat].push(o);
  }
  return groups;
}, [optionsList]);


  const handleCheck = id => {
    setForm(f => {
      const opts = f.options.includes(id)
        ? f.options.filter(x => x !== id)
        : [...f.options, id];
      return { ...f, options: opts };
    });
  };

  function handleReportFileChange(type, file) {
  setReportFiles(f => ({ ...f, [type]: file || null }));
}
//FUNÇÕES DE UPLOAD LAUDOS
async function uploadReport(type) {
  if (!editId) {
    setNotice({ type: 'error', text: 'Salve ou abra um veículo em edição antes de enviar laudos.' });
    return;
  }

  const file = reportFiles[type];
  if (!file) {
    setNotice({ type: 'error', text: `Selecione o PDF do laudo ${type} antes de enviar.` });
    return;
  }

  // validação leve de tipo (o backend também valida)
  if (file.type && file.type !== 'application/pdf') {
    setNotice({ type: 'error', text: 'Apenas arquivos PDF são aceitos.' });
    return;
  }

  setReportUploading(s => ({ ...s, [type]: true }));
  try {
    const fd = new FormData();
    fd.append('type', type);        // 'cautelar' | 'scanner'
    fd.append('report', file);      // campo que o multer espera

    await api.post(`/vehicles/${editId}/reports`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    setNotice({ type: 'success', text: `Laudo ${type} enviado com sucesso.` });
    // limpa o arquivo selecionado
    setReportFiles(f => ({ ...f, [type]: null }));
  } catch (err) {
    setNotice({ type: 'error', text: `Falha ao enviar laudo ${type}: ${readErr(err)}` });
  } finally {
    setReportUploading(s => ({ ...s, [type]: false }));
  }
}


  // ===== Validação de tamanho dos arquivos (50 MB cada) =====
  const MAX_MB = 50;
  const MAX_BYTES = MAX_MB * 1024 * 1024;

  const handleFiles = (e) => {
    const selected = Array.from(e.target.files || []);
    const tooBig = selected.find(f => f.size > MAX_BYTES);

    if (tooBig) {
      setFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
      setNotice({
        type: 'error',
        text: `Arquivo "${tooBig.name}" tem ${(tooBig.size/1024/1024).toFixed(1)} MB. O limite é ${MAX_MB} MB por foto.`
      });
      return;
    }

    setNotice({ type: '', text: '' });
    setFiles(selected);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setNotice({ type: '', text: '' });

    // validação do formulário de veículo
    const validationErrors = validateVehicleForm(form);
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      setNotice({ type: 'error', text: 'Corrija os campos destacados antes de salvar.' });
      return;
    }
    setErrors({});

    // (garantia extra) revalida tamanho dos arquivos antes do submit
    const bad = files.find(f => f.size > MAX_BYTES);
    if (bad) {
      setNotice({
        type: 'error',
        text: `Arquivo "${bad.name}" excede ${MAX_MB} MB. Remova-o e tente novamente.`
      });
      return;
    }

    setSaving(true);
    try {
      // cria ou atualiza veículo
      const payload = {
        ...form,
        fipePrice: form.fipePrice === null ? null : Number(form.fipePrice)
      };
      const creating = !editId;
      const vehicleRes = creating
        ? await api.post('/vehicles', payload, { auth })
        : await api.put(`/vehicles/${editId}`, payload, { auth });

      const vid = creating ? vehicleRes.data.id : editId;

      // envia fotos se houver
      let uploadedCount = 0;
      if (files.length) {
        const fd = new FormData();
        files.forEach(f => fd.append('photos', f)); // multer.array('photos')
        try {
          const upRes = await api.post(`/vehicles/${vid}/photos`, fd, {
            auth,
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          uploadedCount = upRes?.data?.uploaded ?? files.length;
        } catch (errUp) {
          throw new Error(`Falha no upload das fotos: ${readErr(errUp)}`);
        }
      }

      // verifica no servidor se as fotos foram realmente associadas
      let serverPhotoCount = 0;
      try {
        const verify = await api.get(`/vehicles/${vid}`);
        serverPhotoCount = (verify.data?.photos || []).length;
      } catch (errVerify) {
        setNotice({ type: 'warning', text: `Veículo salvo, mas não foi possível verificar as fotos: ${readErr(errVerify)}` });
      }

      setNotice({
        type: 'success',
        text: `Veículo ${creating ? 'criado' : 'atualizado'} com sucesso. `
          + (files.length ? `Fotos enviadas: ${uploadedCount}. ` : '')
          + `Fotos no servidor: ${serverPhotoCount}.`
      });

      // reset do form
      setForm({
        brand: '', model: '', version: '', year: '',
        km: 0, price: 0, fipePrice: null, description: '',
        fuelType: '', transmission: '', engine: '',
        finalPlate: '', doors: 0, color: '', bodyType: '',
        inventoryType: 'locadora',
        videoUrl: '', active: true, options: optionsList.map(o => o.id), photos: [],
        cur_pneus: '',
        cur_rodas: '',
        cur_interior: '',
        cur_pintura: '',
        cur_estrutura: '',
        cur_eletrica: '',
        cur_observacoes: '',
      });
      setFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
      setEditId(null);
      refresh();
    } catch (err) {
      setNotice({ type: 'error', text: `Erro ao salvar: ${readErr(err)}` });
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = async v => {
    setNotice({ type: '', text: '' });
    setErrors({});
    try {
      const res = await api.get(`/vehicles/${v.id}`);
      const veh = res.data;
      setEditId(v.id);
      setForm({
        brand: veh.brand,
        model: veh.model,
        version: veh.version,
        year: veh.year,
        km: veh.km,
        price: veh.price,
        fipePrice: typeof veh.fipePrice === 'number' ? veh.fipePrice : null,
        description: veh.description,
        fuelType: veh.fuelType,
        transmission: veh.transmission,
        engine: veh.engine,
        finalPlate: veh.finalPlate,
        doors: veh.doors,
        color: veh.color,
        bodyType: veh.bodyType,
        inventoryType: veh.inventoryType || 'locadora',
        videoUrl: veh.videoUrl || '',
        active: veh.active,
        options: (veh.options || []).map(o => o.id),
        photos: veh.photos || [],
               // Curadoria
        cur_pneus:       veh.cur_pneus || '',
        cur_rodas:       veh.cur_rodas || '',
        cur_interior:    veh.cur_interior || '',
        cur_pintura:     veh.cur_pintura || '',
        cur_estrutura:   veh.cur_estrutura || '',
        cur_eletrica:    veh.cur_eletrica || '',
        cur_observacoes: veh.cur_observacoes || '',
      });
    } catch (err) {
      setNotice({ type: 'error', text: `Erro ao carregar veículo: ${readErr(err)}` });
    }
  };

  // ===== Remoção em duas etapas =====
  function armRemove(vId) {
    setConfirmingDeleteId(vId);
    if (confirmTimer) clearTimeout(confirmTimer);
    const t = setTimeout(() => setConfirmingDeleteId(null), 6000); // auto-cancel em 6s
    setConfirmTimer(t);
  }

  async function confirmRemove(v) {
    setNotice({ type: '', text: '' });
    try {
      await api.delete(`/vehicles/${v.id}`, { auth });
      setNotice({ type: 'success', text: 'Veículo removido com sucesso.' });
      setConfirmingDeleteId(null);
      refresh();
    } catch (err) {
      setNotice({ type: 'error', text: `Erro ao remover: ${readErr(err)}` });
    }
  }

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2 className="admin-title">
         {`Painel Admin — versão ${ADMIN_PANEL_VERSION}`}
        </h2>
        
        <LogoutButton />
        <HomeButton />
      </div>

      {/* barra de feedback */}
      {notice.text && (
        <div className={`alert ${notice.type}`}>
          {notice.text}
        </div>
      )}

      <form onSubmit={handleSubmit} className="admin-form">
        {/* Marca */}
        <div className="form-group">
          <label htmlFor="brand">Marca</label>
          <input
            list="brand-list"
            id="brand"
            name="brand"
            value={form.brand}
            onChange={handleChange}
            placeholder="Selecione ou digite"
          />
          <datalist id="brand-list">
            {BRAND_OPTIONS.map(b => <option key={b} value={b} />)}
          </datalist>
          {errors.brand && <p className="error">{errors.brand}</p>}
        </div>

        {/* Modelo */}
        <div className="form-group">
          <label>Modelo</label>
          <input name="model" value={form.model} onChange={handleChange} />
          {errors.model && <p className="error">{errors.model}</p>}
        </div>

        {/* Versão */}
        <div className="form-group">
          <label>Versão</label>
          <input name="version" value={form.version} onChange={handleChange} />
          {errors.version && <p className="error">{errors.version}</p>}
        </div>

        {/* Ano / KM */}
        <div className="form-row">
          <div className="form-group half">
            <label>Ano</label>
            <input name="year" value={form.year} onChange={handleChange} />
            {errors.year && <p className="error">{errors.year}</p>}
          </div>
          <div className="form-group half">
            <label>KM</label>
            <input name="km" type="number" value={form.km} onChange={handleNumberChange} />
            {errors.km && <p className="error">{errors.km}</p>}
          </div>
        </div>

        {/* Preço */}
        <div className="form-group">
          <label>Preço</label>
          <input name="price" type="number" value={form.price} onChange={handleNumberChange} />
          {errors.price && <p className="error">{errors.price}</p>}
        </div>

        {/* Preco FIPE */}
        <div className="form-group">
          <label>Preco FIPE</label>
          <input
            name="fipePrice"
            type="number"
            min="0"
            step="0.01"
            value={form.fipePrice ?? ''}
            onChange={handleFipePriceChange}
            placeholder="Opcional: informe a tabela FIPE"
          />
          {errors.fipePrice && <p className="error">{errors.fipePrice}</p>}
          <small className="hint">Usado para mostrar a economia em relacao a FIPE.</small>
        </div>

        {/* Origem do veiculo */}
        <div className="form-group">
          <label htmlFor="inventoryType">Origem do veiculo</label>
          <select
            id="inventoryType"
            name="inventoryType"
            value={form.inventoryType}
            onChange={handleChange}
          >
            <option value="locadora">Locadora parceira</option>
            <option value="estoque">Estoque Connect (proprio)</option>
          </select>
          <p className="form-hint">Escolha onde o carro esta hoje para o site apresentar no lugar certo.</p>
          {errors.inventoryType && <p className="error">{errors.inventoryType}</p>}
        </div>

        {/* Descrição */}
        <div className="form-group">
          <label>Descrição</label>
          <textarea name="description" value={form.description} onChange={handleChange} />
          {errors.description && <p className="error">{errors.description}</p>}
        </div>

        {/* Combustível / Transmissão */}
        <div className="form-row">
          <div className="form-group half">
            <label>Combustível</label>
            <select name="fuelType" value={form.fuelType} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Gasolina Etanol">Gasolina/Etanol</option>
              <option value="Diesel">Diesel</option>
              <option value="Elétrico">Elétrico</option>
            </select>
            {errors.fuelType && <p className="error">{errors.fuelType}</p>}
          </div>
          <div className="form-group half">
            <label>Transmissão</label>
            <select name="transmission" value={form.transmission} onChange={handleChange}>
              <option value="">Selecione</option>
              <option value="Automático">Automático</option>
              <option value="Manual">Manual</option>
            </select>
            {errors.transmission && <p className="error">{errors.transmission}</p>}
          </div>
        </div>

        {/* Motor / Final da placa / Portas */}
        <div className="form-row">
          <div className="form-group third">
            <label>Motor</label>
            <input name="engine" value={form.engine} onChange={handleChange} />
            {errors.engine && <p className="error">{errors.engine}</p>}
          </div>
          <div className="form-group third">
            <label>Final da placa</label>
            <input name="finalPlate" value={form.finalPlate} onChange={handleChange} />
            {errors.finalPlate && <p className="error">{errors.finalPlate}</p>}
          </div>
          <div className="form-group third">
            <label>Portas</label>
            <input name="doors" type="number" value={form.doors} onChange={handleNumberChange} />
            {errors.doors && <p className="error">{errors.doors}</p>}
          </div>
        </div>

        {/* Cor / Tipo de carroceria */}
        <div className="form-row">
          <div className="form-group half">
            <label>Cor</label>
            <input name="color" value={form.color} onChange={handleChange} />
            {errors.color && <p className="error">{errors.color}</p>}
          </div>
          <div className="form-group half">
            <label>Tipo de carroceria</label>
            <input name="bodyType" value={form.bodyType} onChange={handleChange} />
            {errors.bodyType && <p className="error">{errors.bodyType}</p>}
          </div>
        </div>

        {/* Vídeo do YouTube */}
        <div className="form-group">
          <label htmlFor="videoUrl">Vídeo (URL YouTube)</label>
          <input
            type="text"
            name="videoUrl"
            id="videoUrl"
            value={form.videoUrl}
            onChange={handleChange}
            placeholder="https://youtube.com/..."
          />
        </div>

        {/* Ativar/Desativar anúncio */}
        <div className="form-group">
          <label>
            <input type="checkbox" name="active" checked={form.active} onChange={handleChange} />{' '}
            Anúncio ativo
          </label>
        </div>

        {/* Opcionais */}
        {/* Curadoria do veículo */}
<fieldset className="form-group">
  <legend>Curadoria do Veículo</legend>

  <div className="form-row">
    <div className="form-group third">
      <label>Pneus</label>
      <input
        name="cur_pneus"
        value={form.cur_pneus}
        onChange={handleChange}
        placeholder="Ex.: Bom / 70% vida útil"
      />
    </div>
    <div className="form-group third">
      <label>Rodas</label>
      <input
        name="cur_rodas"
        value={form.cur_rodas}
        onChange={handleChange}
        placeholder="Ex.: Sem ralados"
      />
    </div>
    <div className="form-group third">
      <label>Interior</label>
      <input
        name="cur_interior"
        value={form.cur_interior}
        onChange={handleChange}
        placeholder="Ex.: Conservado"
      />
    </div>
  </div>

  <div className="form-row">
    <div className="form-group third">
      <label>Pintura/Lataria</label>
      <input
        name="cur_pintura"
        value={form.cur_pintura}
        onChange={handleChange}
        placeholder="Ex.: Sem repinturas relevantes"
      />
    </div>
    <div className="form-group third">
      <label>Alinhamento/Estrutura</label>
      <input
        name="cur_estrutura"
        value={form.cur_estrutura}
        onChange={handleChange}
        placeholder="Ex.: Sem sinais de colisão"
      />
    </div>
    <div className="form-group third">
      <label>Elétrica/Eletrônica</label>
      <input
        name="cur_eletrica"
        value={form.cur_eletrica}
        onChange={handleChange}
        placeholder="Ex.: OK / sem avarias"
      />
    </div>
  </div>

  <div className="form-group">
    <label>Observações</label>
    <textarea
      name="cur_observacoes"
      value={form.cur_observacoes}
      onChange={handleChange}
      placeholder="Apontamentos específicos deste veículo..."
      rows={3}
    />
  </div>
</fieldset>

 {/* Laudos do veículo (PDF) — aparece apenas no modo edição */}
{editId && (
  <fieldset className="form-group">
    <legend>Laudos do veículo (PDF)</legend>

    <div className="form-row">
      <div className="form-group half">
        <label>Laudo Cautelar (PDF)</label>
        <input
          type="file"
          accept="application/pdf"
          onChange={e => handleReportFileChange('cautelar', e.target.files?.[0] || null)}
        />
        <div style={{ marginTop: 8 }}>
          <button
            type="button"
            className="btn-primary"
            disabled={reportUploading.cautelar || !reportFiles.cautelar}
            onClick={() => uploadReport('cautelar')}
          >
            {reportUploading.cautelar ? 'Enviando...' : 'Enviar laudo cautelar'}
          </button>
        </div>
      </div>

      <div className="form-group half">
        <label>Laudo do Scanner (PDF)</label>
        <input
          type="file"
          accept="application/pdf"
          onChange={e => handleReportFileChange('scanner', e.target.files?.[0] || null)}
        />
        <div style={{ marginTop: 8 }}>
          <button
            type="button"
            className="btn-primary"
            disabled={reportUploading.scanner || !reportFiles.scanner}
            onClick={() => uploadReport('scanner')}
          >
            {reportUploading.scanner ? 'Enviando...' : 'Enviar laudo do scanner'}
          </button>
        </div>
      </div>
    </div>

    <small className="hint">
      Observação: ao enviar um novo laudo do mesmo tipo, os anteriores são automaticamente marcados como inativos.
    </small>
  </fieldset>
)}


        
        <fieldset className="form-group fieldset-options">
  <legend>Opcionais</legend>

  {/* Botões globais */}
  <div style={{ marginBottom: 8, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
    <button type="button" onClick={selectAllOptions} className="btn-secondary">Selecionar todos</button>
    <button type="button" onClick={clearAllOptions} className="btn-danger">Limpar todos</button>
    <button type="button" onClick={selectDefaultOptions} className="btn-primary">Selecionar padrão</button>
  </div>

  {/* Seções por categoria */}
  {CATEGORY_ORDER.map(cat => (
    groupedOptions[cat]?.length ? (
      <div key={cat} className="opt-section">
        <h4 className="opt-title">{cat}</h4>
        <div className="opt-grid">
          {groupedOptions[cat].map(o => (
            <label key={o.id} className="checkbox-inline">
              <input
                type="checkbox"
                checked={form.options.includes(o.id)}
                onChange={() => handleCheck(o.id)}
              />{' '}
              {o.name}
            </label>
          ))}
        </div>
      </div>
    ) : null
  ))}
</fieldset>


        {/* Upload de novas fotos */}
        <div className="form-group">
          <label>Fotos (novas)</label>
          <input
            ref={fileInputRef}
            type="file"
            name="photos"
            multiple
            accept="image/*"
            onChange={handleFiles}
          />
          <small className="hint">Limite: 50 MB por foto.</small>
        </div>

        {/* Editor de fotos existentes */}
        {editId && form.photos.length > 0 && (
          <div className="photo-editor">
            <h4>Fotos atuais</h4>
            <div className="photo-list">
              {form.photos.map(p => (
                <div key={p.id} className="photo-item">
                  <img
                    src={`${API_BASE}/uploads/${p.filename}`}
                    alt=""
                    className={p.isCover ? 'cover' : ''}
                  />
                  <div className="photo-actions">
                    <button
                      type="button"
                      title="Excluir foto"
                      onClick={async () => {
                        try {
                          await api.delete(`/photos/${p.id}`, { auth });
                          setForm(f => ({ ...f, photos: f.photos.filter(x => x.id !== p.id) }));
                          setNotice({ type: 'success', text: 'Foto removida.' });
                        } catch (err) {
                          setNotice({ type: 'error', text: `Erro ao remover foto: ${readErr(err)}` });
                        }
                      }}
                    >
                      🗑️
                    </button>
                    {!p.isCover && (
                      <button
                        type="button"
                        title="Definir como capa"
                        onClick={async () => {
                          try {
                            await api.put(`/photos/${p.id}/cover`, {}, { auth });
                            setForm(f => ({
                              ...f,
                              photos: f.photos.map(x => ({ ...x, isCover: x.id === p.id }))
                            }));
                            setNotice({ type: 'success', text: 'Foto definida como capa.' });
                          } catch (err) {
                            setNotice({ type: 'error', text: `Erro ao definir capa: ${readErr(err)}` });
                          }
                        }}
                      >
                        🌟
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <button type="submit" className="btn-primary" disabled={saving}>
          {saving ? 'Salvando...' : editId ? 'Atualizar veículo' : 'Criar veículo'}
        </button>
      </form>

      <h3 className="admin-subtitle">Veículos cadastrados</h3>
      <ul className="vehicle-list">
        {vehicles.map(v => (
          <li key={v.id} className="vehicle-item">
            <strong>{v.brand} {v.model}</strong> ({v.year})
            <div className="item-actions">
              <button onClick={() => handleEdit(v)} className="btn-secondary">Editar</button>

              {confirmingDeleteId === v.id ? (
                <>
                  <button
                    onClick={() => setConfirmingDeleteId(null)}
                    className="btn-secondary"
                    title="Cancelar"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={() => confirmRemove(v)}
                    className="btn-danger"
                    title="Confirmar remoção"
                  >
                    Confirmar remoção
                  </button>
                </>
              ) : (
                <button
                  onClick={() => armRemove(v.id)}
                  className="btn-danger"
                  title="Remover (vai pedir confirmação)"
                >
                  Remover
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

/* util local pra extrair mensagem do axios */
function readErr(err) {
  return err?.response?.data?.message
      || err?.response?.data?.error
      || err?.message
      || String(err);
}
